import * as React from "react";

function SvgMonitorChartDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M19.428 2.25a3.323 3.323 0 013.315 3.102l.007.219v8.857a3.323 3.323 0 01-3.102 3.315l-.219.007h-4.58l.313 2.5h.695a.75.75 0 01.102 1.493l-.102.007H8.143a.75.75 0 01-.102-1.493l.102-.007h.694l.313-2.5H4.571a3.322 3.322 0 01-3.316-3.133l-.005-.188V5.571a3.322 3.322 0 013.133-3.316l.188-.005h14.857zm-6.091 15.5h-2.675l-.313 2.5h3.301l-.313-2.5zm7.884-3H2.778a1.821 1.821 0 001.637 1.493l.156.007h14.858a1.821 1.821 0 001.758-1.346l.034-.154z"
        />
        <path
          fill="#98DB69"
          d="M19.428 3.75l.16.007a1.82 1.82 0 011.128.526l.109.118c.273.327.425.74.425 1.17v7.679H2.75V5.571l.006-.15A1.822 1.822 0 014.571 3.75h14.857zM12 6.25a.75.75 0 00-.75.75v4l.007.102A.75.75 0 0012.75 11V7l-.007-.102A.75.75 0 0012 6.25zm-4 1a.75.75 0 00-.75.75v3l.007.102A.75.75 0 008.75 11V8l-.007-.102A.75.75 0 008 7.25zm8 1a.75.75 0 00-.75.75v2l.007.102A.75.75 0 0016.75 11V9l-.007-.102A.75.75 0 0016 8.25z"
        />
      </g>
    </svg>
  );
}

export default SvgMonitorChartDuo;
